import { h } from 'preact';
import style from './Button.css';

export default function Button({ children, ...props }) {
	return (
		<button class={style.button} {...props}>{children}</button>
	);
}
